export enum StoreTypeEnum {
  store = 'store',
  retailer = 'retailer',
  ups = 'ups',
  colissimo = 'colissimo',
  inpost = 'inpost',
  packeta = 'packeta',
  gls = 'gls',
  econt = 'econt',
  hermes = 'hermes'
}
